// extracted by mini-css-extract-plugin
export var table = "_yg-0";